import { roundToDecimal } from '@drift/common';

export default function roundPortfolioTradeValue(value: number | undefined) {
	if (value === undefined) {
		return 0;
	}

	return roundToDecimal(value, 2);
}
